import { Price } from "~/common/Store/models/ProductListing";

const applyPlusPricing = (
  price: Price,
  activeSale: boolean,
  hasMapStyle: boolean,
  isQualifiedForBelowMap: boolean,
) => {
  let lowestPrice = Math.min(
    activeSale ? price.salePrice : Infinity,
    price.price,
  );

  if (hasMapStyle) {
    if (!isQualifiedForBelowMap && !activeSale) {
      return false;
    }

    lowestPrice = Math.min(
      price.minimumAdvertisedPriceProperties?.price || Infinity,
      lowestPrice,
    );

    if (price.minimumAdvertisedPriceProperties?.type?.trim() === "G") {
      lowestPrice = Math.min(
        price.minimumAdvertisedPriceProperties.price || Infinity,
        lowestPrice,
      );
    }
  }

  return (
    price.minimumAdvertisedPriceOverride?.priceLevel5 > 0 &&
    price.minimumAdvertisedPriceOverride?.priceLevel5 < lowestPrice
  );
};

export default applyPlusPricing;
